import { useContext } from "react"

import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

import ConfigurationContext from "../../../context/ConfigurationContext"
import useScroll from "../../../hooks/use-Scroll"
import IconInfo from "../../IconInfo/IconInfo"
import Svg from "../../Svg/Svg"

import style from "./AreaHeader.module.scss"

const AreaHeader = ({ title, description, icon, step }) => {
  const context = useContext(ConfigurationContext)
  const { t } = useTranslation();

  const { prevArea, nextArea, goToArea, goToMenu } = context

  const handleGoToPrev = () => {
    goToArea(prevArea)
  }
  const handleGoToNext = () => {
    goToArea(nextArea)
  }
  const y = useScroll()

  return (
    <>
      <h2
        className={[style.areaHeader, y > 2 ? style.scrolling : " "].join(" ")}
      >
        <span className={style.content}>
          <span className={style.sub}>
            <span className={style.left}>
              <button
                className={[style.button, style.listMenu].join(" ")}
                type="button"
                onClick={goToMenu}
              >
                <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.5 13H0.5M16.5 7H0.5M16.5 1H0.5" stroke="white" strokeLinecap="round"/>
                </svg>
              </button>
              <div className={style.titleBlock}>
                <div className={style.stepNumber}>{t("stepOfTotal", {step: step, total: Object.keys(context.allAreas).length})}</div>
                <div>
                  {icon && (
                    <span className={style.contentIcon}>
                      {" "}
                      <Svg src={icon} />
                    </span>
                  )}
                  {title} {description && <IconInfo info={description} />}
                </div>
              </div>
            </span>
            <span className={style.navegation}>
              {prevArea && (
                <button
                  className={[style.button, style.prev, style.nav].join(" ")}
                  type="button"
                  onClick={handleGoToPrev}
                >
                  {/* Left arrow */}
                  <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M20.9495 8.0004C20.9494 8.25038 20.7466 8.45289 20.4966 8.45271L0.78344 8.4388C0.533455 8.43862 0.330946 8.23583 0.331123 7.98584C0.331299 7.73586 0.534094 7.53335 0.784079 7.53353L20.4972 7.54744C20.7472 7.54762 20.9497 7.75041 20.9495 8.0004Z" fill="white"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M7.67989 15.3685C7.4989 15.5409 7.21239 15.534 7.03996 15.353L0.0490218 8.01502L7.03914 0.647681C7.2112 0.466333 7.49769 0.458807 7.67904 0.630868C7.86039 0.80293 7.86791 1.08942 7.69585 1.27077L1.29814 8.01373L7.69539 14.7286C7.86783 14.9095 7.86089 15.1961 7.67989 15.3685Z" fill="white"/>
                  </svg>
                </button>
              )}
              {nextArea && (
                <button
                  className={[style.button, style.next, style.nav].join(" ")}
                  type="button"
                  onClick={handleGoToNext}
                >
                  {/* Right arrow */}
                  <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M0.0485086 7.99963C0.0486851 7.74965 0.25148 7.54714 0.501464 7.54732L20.2146 7.56123C20.4646 7.56141 20.6671 7.7642 20.6669 8.01419C20.6667 8.26417 20.464 8.46668 20.214 8.4665L0.500825 8.45259C0.250841 8.45241 0.0483321 8.24962 0.0485086 7.99963Z" fill="white"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M13.3182 0.631511C13.4991 0.459077 13.7857 0.466016 13.9581 0.64701L20.949 7.98498L13.9589 15.3523C13.7869 15.5337 13.5004 15.5412 13.319 15.3691C13.1377 15.1971 13.1301 14.9106 13.3022 14.7292L19.6999 7.98627L13.3027 1.27145C13.1302 1.09045 13.1372 0.803945 13.3182 0.631511Z" fill="white"/>
                  </svg>
                </button>
              )}
            </span>
          </span>
        </span>
      </h2>
    </>
  )
}

export default AreaHeader

AreaHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  icon: PropTypes.string,
}

AreaHeader.defaultProps = {
  title: "",
  description: "",
  icon: "",
}
